<template>
  <div class="app-version-tooltip">
    <div class="form-tooltip__title">
      Поле "Application ID":
    </div>
    <div v-for="(item, index) in items" :key="index" class="form-tooltip__item">
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  name: "AppVersionTooltip",
  data() {
    return {
      items: [
        'не должно содержать пробелы и кириллицу',
        'не должно содержать спецсимволы, кроме точек',
        'не должно содержать слова "new", "example"',
      ]
    }
  }
}
</script>

<style scoped>

</style>
